import { Button, Flex, Modal } from "antd";

import React from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../../../../common/customTitle";
import { deleteServiceInfoAction } from "../../../../../../redux/services/service-provider-appointments/serviceProviderAppointmentsServices";

const ServiceInfoDeleteDialog = ({ open, onClose, selectedServiceInfoDetails }) => {

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  const {t} = useTranslation();

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* id dependencies */
  const { selectedAppointmentsInfoId } = useSelector(
    (state) => state.serviceProviderAppointments
  );
  /* id dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* initial dependencies */
  useEffect(() => {
    if (
      !selectedServiceInfoDetails ||
      selectedServiceInfoDetails === "" ||
      selectedServiceInfoDetails === null ||
      selectedServiceInfoDetails === undefined
    ) {
      onClose();
    }
  }, [selectedServiceInfoDetails]);
  /* initial dependencies */

  /* perform delete action */
  const handleDelete = () => {
    if (
      selectedServiceInfoDetails &&
      selectedServiceInfoDetails !== "" &&
      selectedServiceInfoDetails !== null &&
      selectedServiceInfoDetails !== undefined
    ) {
      const dataToBeSent = {
        selectedAppointmentsInfoId
      };
      dataToBeSent.extra_service_id = selectedServiceInfoDetails?._id;
      dispatch(deleteServiceInfoAction(dataToBeSent, navigate, setLoading)).then(
        () => {
          onClose();
        }
      );
    }
  };
  /* perform delete action */

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
        {t("Modules.Offer.OfferForm.deleteOffer")}

        </CustomTitle>
        <Title level={2}>{t("deleteTitle")}</Title>
        <Flex gap="1rem" align="center" justify="center">
          <Button type="primary" onClick={handleDelete}>
          {t("confirmationPopup.buttonYesText")}

          </Button>
          <Button type="default" onClick={onClose}>
          {t("confirmationPopup.buttonNoText")}

          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ServiceInfoDeleteDialog;
